import { Bar, mixins } from 'vue-chartjs'

export default {
  extends: Bar,
  mixins: [mixins.reactiveProp],
  props: ['chartData', 'options'],
  watch: {
    chartData: function () {
      this.$data._chart.destroy()
      this.renderChart(this.chartData, this.options)
    }
  },
  mounted () {
    this.renderChart(this.chartData, this.options)
  }
}



// WEBPACK FOOTER //
// ./src/util/BarLineMixedChart.js